// extracted by mini-css-extract-plugin
export default {"container":"sharecopy_container__z1pZm","icon":"sharecopy_icon__1zgFH","blue":"sharecopy_blue__1PDZZ","purple":"sharecopy_purple__2919g","white":"sharecopy_white__1V_O0"};